import { render, staticRenderFns } from "./FormRender.vue?vue&type=template&id=d150da4c"
import script from "./FormRender.vue?vue&type=script&lang=ts"
export * from "./FormRender.vue?vue&type=script&lang=ts"
import style0 from "./FormRender.vue?vue&type=style&index=0&id=d150da4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports